export default {
  // Page title and subtitle
  'page.mainTitle': 'Discord टाइमस्टैम्प जनरेटर',
  'page.mainTitleSEO': 'Discord टाइमस्टैम्प जनरेटर - गतिशील <t:format> कोड बनाएं',
  'page.subtitle': 'सभी के लिए स्वचालित टाइमज़ोन रूपांतरण के साथ Discord टाइमस्टैम्प जनरेट करें',

  // Generator tool section
  'page.generatorTitle': 'इंटरैक्टिव Discord टाइमस्टैम्प जनरेटर',
  'page.selectDateTime': 'तारीख और समय चुनें:',
  'page.chooseFormat': 'प्रदर्शन प्रारूप चुनें:',
  'page.generatedCode': 'जनरेट किया गया Discord कोड:',
  'page.preview': 'Discord में पूर्वावलोकन:',
  'page.copyCode': 'कोड कॉपी करें',

  // Format options
  'page.format.t': 'संक्षिप्त समय',
  'page.format.t.example': '4:30 PM',
  'page.format.t.desc': 'केवल समय प्रदर्शित करता है, संक्षिप्त प्रारूप',

  'page.format.T': 'लंबा समय',
  'page.format.T.example': '4:30:00 PM',
  'page.format.T.desc': 'केवल समय प्रदर्शित करता है, सेकंड के साथ',

  'page.format.d': 'संक्षिप्त तारीख',
  'page.format.d.example': '12/31/2024',
  'page.format.d.desc': 'केवल तारीख प्रदर्शित करता है, संक्षिप्त प्रारूप',

  'page.format.D': 'लंबी तारीख',
  'page.format.D.example': 'December 31, 2024',
  'page.format.D.desc': 'पूर्ण तारीख प्रदर्शित करता है',

  'page.format.f': 'संक्षिप्त तारीख/समय',
  'page.format.f.example': 'December 31, 2024 4:30 PM',
  'page.format.f.desc': 'सबसे अधिक उपयोग किया जाने वाला प्रारूप',

  'page.format.F': 'लंबी तारीख/समय',
  'page.format.F.example': 'Tuesday, December 31, 2024 4:30 PM',
  'page.format.F.desc': 'सप्ताह के दिन के साथ पूर्ण तारीख और समय',

  'page.format.R': 'सापेक्ष समय',
  'page.format.R.example': '2 घंटे पहले / 3 दिनों में',
  'page.format.R.desc': 'गतिशील काउंटडाउन या बीता हुआ समय',

  // Format reference table
  'page.formatReference': 'Discord टाइमस्टैम्प प्रारूप संदर्भ',
  'page.formatCode': 'प्रारूप कोड',
  'page.style': 'शैली',
  'page.exampleOutput': 'उदाहरण आउटपुट',
  'page.useCase': 'उपयोग का मामला',

  'page.useCase.t': 'इवेंट शुरू होने का समय',
  'page.useCase.T': 'सटीक समय',
  'page.useCase.d': 'कॉम्पैक्ट तारीख प्रदर्शन',
  'page.useCase.D': 'पूर्ण तारीख प्रदर्शन',
  'page.useCase.f': 'सामान्य उद्देश्य',
  'page.useCase.F': 'औपचारिक घोषणाएं',
  'page.useCase.R': 'काउंटडाउन, इवेंट के बाद से समय',

  // How to use section
  'page.howToUse': 'Discord टाइमस्टैम्प का उपयोग कैसे करें',
  'page.step1': 'अपना टाइमस्टैम्प कोड जनरेट करें',
  'page.step1Desc': 'तारीख/समय और प्रारूप चुनने के लिए ऊपर टूल का उपयोग करें',

  'page.step2': 'जनरेट किए गए कोड को कॉपी करें',
  'page.step2Desc': 'उदाहरण: <t:1735689000:F>',

  'page.step3': 'किसी भी Discord संदेश में पेस्ट करें',
  'page.step3Desc': 'टेक्स्ट चैनल, DM, थ्रेड्स और फ़ोरम पोस्ट में काम करता है',

  'page.step4': 'हर कोई इसे अपने टाइमज़ोन में देखता है!',
  'page.step4Desc': 'Discord स्वचालित रूप से प्रत्येक उपयोगकर्ता के स्थानीय समय में कन्वर्ट करता है',

  // FAQ section
  'page.faq': 'Discord टाइमस्टैम्प FAQ',

  'page.faq.q1': 'Discord टाइमस्टैम्प क्या है?',
  'page.faq.a1': 'Discord टाइमस्टैम्प विशेष प्रारूप कोड (<t:timestamp:format>) के साथ Unix epoch समय का उपयोग करते हैं जो गतिशील समय प्रदर्शित करते हैं जो स्वचालित रूप से प्रत्येक उपयोगकर्ता के स्थानीय टाइमज़ोन में समायोजित होते हैं।',

  'page.faq.q2': 'समय टाइप करने के बजाय Discord टाइमस्टैम्प का उपयोग क्यों करें?',
  'page.faq.a2': 'Discord टाइमस्टैम्प स्वचालित रूप से प्रत्येक उपयोगकर्ता के स्थानीय टाइमज़ोन में कन्वर्ट होते हैं, इसलिए हर कोई अपने स्थान के लिए सही समय देखता है। यह समय क्षेत्रों में इवेंट का समन्वय करते समय भ्रम को समाप्त करता है।',

  'page.faq.q3': 'मुझे किस प्रारूप का उपयोग करना चाहिए?',
  'page.faq.a3': 'काउंटडाउन और इवेंट के लिए <t:timestamp:R>, औपचारिक घोषणाओं के लिए <t:timestamp:F>, और सामान्य उद्देश्यों के लिए <t:timestamp:f> का उपयोग करें।',

  'page.faq.q4': 'क्या Discord टाइमस्टैम्प सभी चैनलों में काम करते हैं?',
  'page.faq.a4': 'हां! Discord टाइमस्टैम्प टेक्स्ट चैनल, DM, थ्रेड्स, फ़ोरम पोस्ट और यहां तक कि चैनल विषयों में भी काम करते हैं।',

  'page.faq.q5': 'क्या मैं Discord टाइमस्टैम्प को एम्बेड में उपयोग कर सकता हूं?',
  'page.faq.a5': 'हां, Discord बॉट का उपयोग करते समय Discord टाइमस्टैम्प एम्बेड विवरण और फ़ील्ड मानों में काम करते हैं।',

  'page.faq.q6': 'यदि मैं अमान्य टाइमस्टैम्प का उपयोग करता हूं तो क्या होता है?',
  'page.faq.a6': 'Discord कच्चे कोड को बिना कन्वर्ट किए प्रदर्शित करेगा। सुनिश्चित करें कि मान्य Unix टाइमस्टैम्प का उपयोग करें।',

  // Related tools section
  'page.relatedTools': 'संबंधित टाइमस्टैम्प टूल',
  'page.needUnixTimestamp': 'Unix टाइमस्टैम्प की आवश्यकता है?',
  'page.needUnixTimestampDesc': 'किसी भी तारीख को epoch समय में कन्वर्ट करने के लिए हमारे Unix टाइमस्टैम्प कनवर्टर का उपयोग करें।',
  'page.checkYouTubeTool': 'या YouTube टाइमस्टैम्प निर्माता देखें',

  // Common use cases
  'page.commonUseCases': 'सामान्य उपयोग के मामले',
  'page.useCase1.title': 'इवेंट शेड्यूलिंग',
  'page.useCase1.desc': 'गेम नाइट, मूवी वॉच पार्टी या सामुदायिक इवेंट की घोषणा करें',

  'page.useCase2.title': 'रेड टाइमर',
  'page.useCase2.desc': 'विभिन्न समय क्षेत्रों में गेमिंग सत्रों का समन्वय करें',

  'page.useCase3.title': 'रिलीज़ काउंटडाउन',
  'page.useCase3.desc': 'गेम लॉन्च, एल्बम ड्रॉप या अपडेट के लिए उत्साह पैदा करें',

  'page.useCase4.title': 'बैठक अनुस्मारक',
  'page.useCase4.desc': 'सामुदायिक सर्वरों में टीम बैठकों को शेड्यूल करें',

  'page.useCase5.title': 'प्रतियोगिता समय सीमा',
  'page.useCase5.desc': 'उपहार और प्रतियोगिताओं के लिए स्पष्ट समय सीमा निर्धारित करें',

  'page.useCase6.title': 'सर्वर इवेंट',
  'page.useCase6.desc': 'वर्षगांठ, मील के पत्थर और विशेष अवसरों को ट्रैक करें',
};